import { scroller } from 'react-scroll'

import { ScrollAnimation } from 'constants/scroll'

export const scrollToComment = (idName: string, id: number): void => {
  const elementName = `CommentAnchorBy${idName}_${id}`

  scroller.scrollTo(elementName, ScrollAnimation)
}
